import { Splide } from '@splidejs/splide';
export const initHeroSlider = () => {
    const heroSlider = document.querySelector('#hero-slider');
    if (!heroSlider)
        return;
    new Splide(heroSlider, {
        type: 'loop',
        autoplay: true,
        interval: 7000
    }).mount();
};
